import { FormApi } from 'final-form';
import React, { Fragment, useContext, useState } from 'react';
import { AlertBox, LocaleContext } from 'shared';
import { LoginPayload } from 'store/api/types';

import { ResetPasswordProps } from './ResetPassword.types';
import { ResetPasswordForm } from './resetPasswordForm/ResetPasswordForm';

export const ResetPassword = ({ onResetPassword, ...rest }: ResetPasswordProps) => {
  const [isSubmitFailed, setSubmitFail] = useState(false);
  const [isSubmitSuccess, setSubmitSuccess] = useState(false);
  const [reCaptchaKey, setReCaptchaKey] = useState(`true`);
  const context = useContext(LocaleContext);

  const handleSubmit = async (values: LoginPayload, formApi: FormApi) => {
    try {
      return await onResetPassword(values, formApi, () => {
        setSubmitSuccess(true);
      });
    } catch (error) {
      resetReCaptcha();
      setSubmitFail(true);
    }
  };

  const resetReCaptcha = () => setReCaptchaKey(reCaptchaKey === 'true' ? 'false' : 'true');

  return (
    <Fragment>
      {!isSubmitSuccess && (
        <ResetPasswordForm
          {...rest}
          onSubmit={handleSubmit}
          isSubmitFailed={isSubmitFailed}
          reCaptchaKey={reCaptchaKey}
        />
      )}
      {isSubmitSuccess && (
        <AlertBox type={AlertBox.types.SUCCESS} title={context.formatMessage({ id: 'RESET-PASSWORD.SUCCESS.TITLE' })}>
          {context.formatMessage({ id: 'RESET-PASSWORD.SUCCESS.CONTENT' })}
        </AlertBox>
      )}
    </Fragment>
  );
};
